module.exports = __webpack_public_path__ + "static/media/secondDemoBg.8fb4c326.svg";